export class TextValue<T> {

  constructor(public text: string, public value: T) {
  }

}
